import CardCreateOrder from 'components/Cards/CardCreateOrder'
import React from 'react'


export default function CreateOrders() {
  return (
    <>
      <div className="flex flex-wrap mt-4 "style={{height:"1200px"}}>
        <div className="w-full px-4 mb-12 " >
          <CardCreateOrder></CardCreateOrder>
        </div>
      </div>
    </>
  )
}
